import { render, staticRenderFns } from "./AboutUsheader.vue?vue&type=template&id=27985da5"
import script from "./AboutUsheader.vue?vue&type=script&lang=js"
export * from "./AboutUsheader.vue?vue&type=script&lang=js"
import style0 from "./AboutUsheader.vue?vue&type=style&index=0&id=27985da5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports